module.exports = __webpack_public_path__ + "img/writing.85e7e155.svg";